import React, { useCallback, useMemo } from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import RosterUserDialog from "@/components/Dialog/rosterUserDialog";
import Layout from "@/components/layout";
import Title from "@/components/title";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
// Fetch
import {
  deleteRosterByUser,
  getRosterByLocation,
  upsertRosterByUser,
} from "@/fetch/fetchRoster";
import { getWorkLocation } from "@/fetch/fetchWork";
import { useCurrentAction } from "@/hooks/user";
import getDateRange from "@/lib/getDateRange";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import _ from "lodash";
import "react-big-calendar/lib/css/react-big-calendar.css";

const SystemSettingRosterPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const [isDialogOpen, setDialogOpen] = React.useState(false);
  const [event, setEvent] = React.useState([]);
  const [shopName, setShopName] = React.useState("");
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  // Navigate
  const navigate = useNavigate();
  const localizer = momentLocalizer(moment);
  const params = useParams();
  const eventPropGetter = useCallback((event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: event.backgroundColor,
        color: "black",
      },
    };
  }, []);
  const [myEvents, setEvents] = React.useState({});
  const { defaultDate } = useMemo(
    () => ({
      defaultDate: moment(params.date),
    }),
    [params.date]
  );
  const handleDelete = async () => {
    const answer = window.confirm("確定要刪除嗎，會連同打卡紀錄一起刪除？");
    if (answer) {
      await deleteRosterByUser(myEvents.user_id, myEvents.date);
      setDialogOpen(false);

      fetchAll();
    }
  };
  const handleSelectSlot = useCallback(({ start, end }) => {
    setDialogOpen(true);
    setEvents({
      is_leave: false,
      leave_type: "",
      location_id: null,
      start_date: start,
      end_date: start,
      roster: "FULL",
      roster_value: "FULL",
      is_off: false,
      user_id: null,
      value: "",
      street: null,
    });
  }, []);

  const handleOnChange = (value, key) => {
    setEvents((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const handleOnUserChange = (value) => {
    setEvents((prev) => {
      return {
        ...prev,
        ...value,
      };
    });
  };
  const handleSelectEvent = useCallback((event) => {
    setDialogOpen(true);
    setEvents({ ...event, start_date: event.date, end_date: event.date });
  }, []);

  const handleSubmit = async () => {
    let payload = [];
    try {
      const dataRanges = getDateRange(myEvents.start_date, myEvents.end_date);
      payload = _.map(dataRanges, (dataRange) => {
        return {
          date: moment(dataRange).format("YYYY-MM-DD"),
          is_off: myEvents.is_off,
          is_leave: myEvents.is_leave,
          leave_type: myEvents.leave_type,
          location_id: params.location_id,
          user_id: myEvents.user_id,
          roster: myEvents.roster_value,
          street: myEvents.street,
          time_checkedin: myEvents.time_checkedin,
          time_checkedout: myEvents.time_checkedout,
        };
      });
      setSnackSeverity("success");
      setSnackMessage("更新成功");
      setSnackOpen(true);
      await upsertRosterByUser(payload);
    } catch (err) {
      setSnackSeverity("errro");
      setSnackMessage(`更新失敗\n${err.message}`);
      setSnackOpen(true);
    } finally {
      setDialogOpen(false);
      fetchAll();
    }
  };
  // Fetch
  const fetchAll = async () => {
    const { location_id, date } = params;
    const start = moment(date)
      .subtract(1, "year")
      .startOf("year")
      .format("YYYY-MM-DD");
    const end = moment(date).add(1, "year").endOf("year").format("YYYY-MM-DD");
    const rosters = await getRosterByLocation(location_id, start, end);
    const { data: location } = await getWorkLocation(location_id);
    let lastTitle = "";
    const formattedEvent = [];
    let title = "";

    _.forEach(rosters.data, (roster) => {
      let backgroundColor = "#fde9d9";
      if (roster.is_off) {
        title = roster.off_type;
        backgroundColor = "#d09996";
      } else if (roster.user_id) {
        title = `${roster.alias} (${roster.roster}) ${
          roster.street ? `(${roster.street}街)` : ""
        }`;
        backgroundColor = "#deedf2";
      } else if (roster.is_leave) {
        title = roster.leave_type;
        backgroundColor = "#deedf2";
      } else {
        title = `${roster.work_name} (${roster.roster})`;
      }
      formattedEvent.push({
        title,
        start: new Date(`${roster.date} ${roster.start_time ?? "11:00:00"}`),
        end: new Date(`${roster.date} ${roster.end_time ?? "19:00:00"}`),
        ...roster,
        backgroundColor,
      });
      //   if (lastTitle === title) {
      //     const lastIndex = formattedEvent.length - 1;
      //     formattedEvent[lastIndex].end = new Date(roster.date);
      //   } else {
      //     formattedEvent.push({
      //       title,
      //       start: new Date(roster.date),
      //       end: new Date(roster.date),
      //       ...roster,
      //       backgroundColor,
      //     });
      //   }
      lastTitle = title;
    });
    console.log("formattedEvent", formattedEvent);
    setEvent(formattedEvent);
    setShopName(`(${location.work_shortcode}) ${location.work_name}`);
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Layout
      header="RosterPage"
      selectedIndex={22}
      open={open}
      setOpen={setOpen}
      snackClose={() => setSnackOpen(false)}
      snackSeverity={snackSeverity}
      snackMessage={snackMessage}
      snackOpen={snackOpen}
    >
      <Title
        history={() => navigate(-1)}
        title="更表"
        children={
          <>
            <div>
              <LocationOnIcon
                style={{ verticalAlign: "middle" }}
              ></LocationOnIcon>
              {shopName}
            </div>
            <div></div>
            <div></div>
          </>
        }
      />
      <RosterUserDialog
        open={isDialogOpen}
        cancelMessage={"取消"}
        actions={actions}
        submitMessage={"提交"}
        event={myEvents}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        handleOnChange={handleOnChange}
        handleOnUserChange={handleOnUserChange}
        onCancel={() => setDialogOpen(!isDialogOpen)}
      ></RosterUserDialog>
      <Calendar
        localizer={localizer}
        eventPropGetter={eventPropGetter}
        events={event}
        defaultDate={defaultDate}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={handleSelectEvent}
        onSelectSlot={handleSelectSlot}
        style={{ height: 650 }}
        showMultiDayTimes={true}
        selectable
        messages={{
          previous: "上個月",
          next: "下個月",
          today: "今月",
        }}
      />
    </Layout>
  );
};

export default SystemSettingRosterPage;
